// extracted by mini-css-extract-plugin
module.exports = {"loadReviews":"LoadReviews_loadReviews__YPwAw","loadingIndicator":"LoadReviews_loadingIndicator__kayUj"};